import { DependencyList, EffectCallback, useEffect, useRef } from "react";

/**
 * A custom useEffect hook that only triggers on updates, not on initial mount
 */
export const useUpdateEffect = (callback: EffectCallback, dependencies: DependencyList = []) => {
    const isFirst = useIsFirstRender();

    useEffect(() => {
        if (!isFirst) {
            return callback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};

const useIsFirstRender = () => {
    const isFirst = useRef(true);

    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }

    return isFirst.current;
};
